<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useGalleryToast } from '@/composables/useGalleryToast'
import type { GalleryToast } from '@/composables/useGalleryToast'

const { t } = useI18n()
const { toasts, dismiss } = useGalleryToast()

function runAction(toast: GalleryToast): void {
  toast.onAction?.()
  dismiss(toast.id)
}
</script>

<template>
  <div
    v-if="toasts.length > 0"
    class="fixed top-20 right-4 z-60 flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2"
    aria-live="polite"
    data-testid="gallery-toasts"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="flex items-start gap-3 rounded-xl border px-4 py-3 text-sm shadow-xl"
      :class="toast.kind === 'error'
        ? 'bg-red-950 border-red-500/40 text-red-200'
        : toast.kind === 'success'
          ? 'bg-slate-800 border-emerald-500/40 text-emerald-200'
          : 'bg-slate-800 border-slate-600 text-slate-200'"
      :role="toast.kind === 'error' ? 'alert' : 'status'"
    >
      <p class="flex-1">{{ toast.message }}</p>
      <button
        v-if="toast.actionLabel"
        type="button"
        class="font-semibold underline underline-offset-2 hover:text-white"
        @click="runAction(toast)"
      >
        {{ toast.actionLabel }}
      </button>
      <button
        type="button"
        class="text-slate-400 hover:text-white"
        :aria-label="t('common.close')"
        @click="dismiss(toast.id)"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</template>
